module.exports = __webpack_public_path__ + "img/gb13871-92_28x40x7.prt.a5866329.jpg";